import React from 'react'
import { Container, Title, Paper, LoadingOverlay } from '@mantine/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useAppTranslation } from 'hooks/useTranslation'
import { notifications } from '@mantine/notifications'

import { CampaignForm } from 'components/campaigns'
import { createCampaign, CreateCampaignData } from 'supabase/campaigns'

export function CreateCampaignPage() {
  const { t } = useAppTranslation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createCampaignMutation = useMutation({
    mutationFn: createCampaign,
    onSuccess: (data) => {
      // Invalidate campaigns query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['campaigns'] })
      queryClient.invalidateQueries({ queryKey: ['campaigns-with-impressions'] })

      // Show success notification
      notifications.show({
        title: t('campaigns.campaign_created'),
        message: t('campaigns.campaign_created_success'),
        color: 'green'
      })

      // Navigate to campaigns list or campaign detail
      navigate('/campaigns')
    },
    onError: (error) => {
      console.error('Error creating campaign:', error)
      notifications.show({
        title: t('common.error'),
        message: error.message || 'Failed to create campaign',
        color: 'red'
      })
    }
  })

  const handleSubmit = (data: CreateCampaignData) => {
    createCampaignMutation.mutate(data)
  }

  return (
    <Container size="md" py="xl">
      <Title order={1} mb="lg">
        {t('campaigns.create_campaign')}
      </Title>

      <Paper pos="relative">
        <LoadingOverlay visible={createCampaignMutation.isPending} />
        <CampaignForm
          onSubmit={handleSubmit}
          loading={createCampaignMutation.isPending}
        />
      </Paper>
    </Container>
  )
}